import React from 'react';
import Tooltip from 'components/tooltip';
import './button.scss';

export default class Button extends React.Component {
  render() {
    const {
      size = 'md',
      type = 'default',
      styleType,
      className,
      disabled,
      tooltip,
      ...props
    } = this.props;
    const buttonStyleType = styleType || (type === 'submit' ? 'default' : type);
    const buttonType =
      type === 'submit' || type === 'primary' ? 'submit' : 'button';

    let classNameExt = `button button-${size} button-${buttonStyleType}`;
    if (className) {
      classNameExt += ` ${className}`;
    }

    const button = (
      <button
        type={buttonType}
        className={`${classNameExt} ${
          !styleType && disabled ? 'button-disabled' : ''
        }`}
        disabled={disabled}
        ref="button"
        {...props}
      >
        {props.children}
      </button>
    );

    if (tooltip) {
      return <Tooltip message={tooltip}>{button}</Tooltip>;
    }

    return button;
  }
}
